import { Grid } from '@mui/material'
import { ExecutedMovesTimeRangeDto } from '@operations/app/api'
import { observer } from 'mobx-react-lite'
import { IVesselKPIColumn } from '../../models/vessel-kpi'
import { VesselKpiTableCell } from '../atoms/VesselKpiTableCell'

interface Props {
  column: IVesselKPIColumn
  moves: ExecutedMovesTimeRangeDto
}
export const TotalTableContent = observer(({ column, moves }: Props) => {
  return (
    <Grid container>
      {column.hasInbound && (
        <VesselKpiTableCell column={column} skipTotal value={moves.totalInboundAmount} />
      )}
      {column.hasOutbound && (
        <VesselKpiTableCell column={column} skipTotal value={moves.totalOutboundAmount} />
      )}
      {column.hasRestow && (
        <VesselKpiTableCell column={column} skipTotal value={moves.totalRestowAmount} />
      )}
    </Grid>
  )
})
